/**
 * AnalyticsRouteWatcher — launch-readiness item 2 (2026-09-18).
 * Mount once inside <BrowserRouter> (App.tsx). Reports a `page_view` on every
 * SPA route change and keeps the batched tracker flushing. See
 * src/services/analyticsTracker.ts for the privacy-light design.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, scheduleFlush, trackPageView } from '../services/analyticsTracker';

export function AnalyticsRouteWatcher(): null {
  const location = useLocation();
  useEffect(() => {
    initAnalytics();
    scheduleFlush();
    trackPageView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  return null;
}

export default AnalyticsRouteWatcher;
